import { render, staticRenderFns } from "./CustomerAppointmentHome.vue?vue&type=template&id=f23be1ae&scoped=true"
import script from "./CustomerAppointmentHome.vue?vue&type=script&lang=js"
export * from "./CustomerAppointmentHome.vue?vue&type=script&lang=js"
import style0 from "./CustomerAppointmentHome.vue?vue&type=style&index=0&id=f23be1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23be1ae",
  null
  
)

export default component.exports